import { AudienceGroupOption } from '../../../../types/domainModels';

import FormInput from 'components/common/forms/FormInput';
import FormSearchSelectInput from 'components/common/forms/FormSearchSelectInput';
import {
  AUDIENCE_TARGET_TYPE,
  logicalModifierOptionsForTargetEnum,
  logicalModifierOptionsForTargetRange,
} from 'util/demographics';

import { TargetConstraints } from './TargetConstraints';

export const Target = ({
  audienceGroupOptions,
  index,
  namePrefix,
  onClickRemoveTarget,
  selectedAudienceGroupId,
}: {
  audienceGroupOptions: AudienceGroupOption[];
  index: number;
  namePrefix: string;
  onClickRemoveTarget?: () => void;
  selectedAudienceGroupId: number;
}): JSX.Element => {
  const targetFieldName = `${namePrefix}.${index}`;

  return (
    <div className="flex flex-col p-2 space-y-4">
      <div className="text-xs font-medium text-gray-900 flex flex-row justify-between">
        <div>Target {index + 1}</div>
        {onClickRemoveTarget && (
          <div
            className="font-normal text-red underline cursor-pointer"
            onClick={onClickRemoveTarget}
          >
            Delete this target
          </div>
        )}
      </div>

      <div className="flex flex-row items-start w-full space-x-4">
        <div className="flex-1">
          <FormInput
            icon="%"
            iconPlacement="trailing"
            max={100}
            min={0}
            name={`${targetFieldName}.percentage`}
            size="md"
            type="number"
          />
        </div>
        <div className="flex-1">
          <FormSearchSelectInput
            borderColor="#D9D9D9"
            name={`${targetFieldName}.logicalModifier`}
            options={
              selectedAudienceGroupId === AUDIENCE_TARGET_TYPE.RANGE
                ? logicalModifierOptionsForTargetRange
                : logicalModifierOptionsForTargetEnum
            }
            placeholder="Select condition"
          />
        </div>
      </div>

      <div className="flex-1">
        <TargetConstraints
          audienceGroupOptions={audienceGroupOptions}
          namePrefix={targetFieldName}
          selectedAudienceGroupId={selectedAudienceGroupId}
        />
      </div>
    </div>
  );
};
